/** @jsxImportSource @emotion/react */
import React from "react";
import {
    DialogOverlay, DialogBox, DialogHeader, DialogBody, DialogFooter,
    DialogCloseBtn, DialogBtn, FormField, InfoText,
} from "./ANCInterventionStyles";
import TextField from "../../../Utils/FormInputs/TextField";
import { ResizableTextarea } from "../../../Utils/FormInputs/Textarea";
import Form from "react-bootstrap/Form";
import Label from "../../../Utils/FormInputs/Label";

/**
 * ANCRecordInterventionDialog — Modal for recording an administered dose
 */
export const ANCRecordInterventionDialog = (props) => {
    const { recordDialog, formData, handleFormChange, submitRecord, closeRecordDialog, saving } = props;

    if (!recordDialog.open || !recordDialog.intervention) return null;

    const intervention = recordDialog.intervention;
    const doseNum = recordDialog.doseNumber || 1;
    const doseLabel = intervention.doseLabels
        ? intervention.doseLabels[doseNum - 1] || "Dose " + doseNum
        : "Dose " + doseNum;

    const submitLabel = saving
        ? "Saving..."
        : intervention.category === "hiv"
            ? "Confirm " + doseLabel
            : "Record " + doseLabel;

    const quantityLabel = intervention.hasQuantity
        ? (intervention.key === "aspirin" ? "Quantity" : "Number of Tablets Dispensed")
        : null;

    return (
        <DialogOverlay onClick={function(e) { if (e.target === e.currentTarget) closeRecordDialog(); }}>
            <DialogBox>
                {/* Header */}
                <DialogHeader>
                    <h4> {intervention.category === "hiv" ? "Confirm" : "Record"} {intervention.label}</h4>
                    <DialogCloseBtn onClick={closeRecordDialog}>×</DialogCloseBtn>
                </DialogHeader>

                {/* Body */}
                <DialogBody>
                    {/* Info */}
                    <InfoText style={{ marginBottom: 18 }}>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>{doseLabel}</div>
                        <div style={{ fontSize: "0.78rem", color: "#78909c" }}>{intervention.notes}</div>
                    </InfoText>

                    {/* Date */}
                    <Form.Group>
                        <Label name='Date Given'/>
                        <TextField
                            type="date"
                            name="date_given"
                            value={formData.date_given || ""}
                            onChange={function(e) { handleFormChange("date_given", e.target.value); }}
                        />
                    </Form.Group>

                    {/* Quantity — iron/folic acid, calcium, aspirin */}
                    {intervention.hasQuantity && (
                        <Form.Group>
                            <Label name={quantityLabel}/>
                            <TextField
                                type="number"
                                name="quantity"
                                min="0"
                                placeholder="e.g. 30"
                                value={formData.quantity || ""}
                                onChange={function(e) { handleFormChange("quantity", e.target.value); }}
                            />
                        </Form.Group>
                    )}

                    {/* Prescription ID — pharmacy-dispensed items only */}
                    {/* {intervention.hasPharmacy && (
                        <Form.Group>
                            <label>Prescription ID (Optional)</label>
                            <input
                                type="number"
                                min="1"
                                placeholder="Link to pharmacy prescription e.g. 1234"
                                value={formData.prescription_id || ""}
                                onChange={function(e) { handleFormChange("prescription_id", e.target.value); }}
                            />
                            <small style={{ color: "#90a4ae", fontSize: "0.72rem" }}>
                                Enter the Prescription ID from the pharmacy module. Leave blank if dispensed from ward stock.
                            </small>
                        </Form.Group>
                    )} */}

                    {/* Notes */}
                    <Form.Group>
                        <Label name="Notes (Optional)"/>
                        <ResizableTextarea
                            rows={3}
                            name="notes"
                            placeholder="Any relevant observations..."
                            value={formData.notes || ""}
                            onChange={function(e) { handleFormChange("notes", e.target.value); }}
                        />
                    </Form.Group>
                </DialogBody>

                {/* Footer */}
                <DialogFooter>
                    <DialogBtn onClick={closeRecordDialog}>Cancel</DialogBtn>
                    <button
                    className="btn sms-info-btn"
                        variant="primary"
                        disabled={saving || !formData.date_given}
                        onClick={submitRecord}
                    >
                        {submitLabel}
                    </button>
                </DialogFooter>
            </DialogBox>
        </DialogOverlay>
    );
};
